module.exports = __webpack_public_path__ + "img/custom-item1-4.d7ea700.png";